"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.NavTooltip = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Popup = _interopRequireDefault(require("./Popup"));

var NavTooltip = function NavTooltip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom right' : _ref$position,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "position"]);
  return /*#__PURE__*/_react["default"].createElement(_Popup["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])('cloud-ui-nav-tooltip', className),
    on: "hover",
    position: position
  }, props), children);
};

exports.NavTooltip = NavTooltip;
var _default = NavTooltip;
exports["default"] = _default;